import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import getFormatById from '@/assets/formats/get-format-by-id'
import { autoHealStoredBasicData } from '@/utils/basic-data-sanitizer'
/* トップ以外は非同期読み込み */
import formatList from '@/views/FormatList'
import formatKeirekishoList from '@/views/FormatKeirekishoList'
// import top from '@/views/Top'
import top from '@/views/TopCommon'
import oemConfigs from '@/plugins/oem'
import top_new from '@/views/Top_new'
Vue.use(Router)

const SITE_TITLE = process.env.VUE_APP_SITE_TITLE
const NOT_FOUND_PATH = '/404'

const previewProps = function (route) {
  return {
    preview: true,
    formatId: route.params.formatId,
    cardId: route.params.cardId
  }
}

const onlyPreviewProps = function (route) {
  return {
    isLight: true,
    uuid: route.params.uuid
  }
}
const getCardTitle = function (cards, cardId) {
  const result = cards.find(function (card) {
    return card.id === cardId
  })
  if (result) return result.title
}

const getFormatMeta = function (formatId, cardId) {
  const result = getFormatById(formatId)
  if (result) {
    return {
      title: result.title,
      description: result.description,
      cardTitle: getCardTitle(result.cards, cardId)
    }
  }
}

/*
** SEO用 title、meta descriptionを作成
*/
const setFormatMeta = function (to) {
  const formatMeta = getFormatMeta(to.params.formatId, to.params.cardId)
  if (!formatMeta) {
    console.error('format meta not set.')
    return
  }
  if (formatMeta.cardTitle) {
    // document.title = `${formatMeta.cardTitle}  ${formatMeta.title} ${to.meta.title}`
    document.title = `${formatMeta.title} ${to.meta.title}`
    // metaDescriptionElement.content = `${formatMeta.title}の${formatMeta.cardTitle}のページです。${formatMeta.description}`
    metaDescriptionElement.content = `${formatMeta.title}テンプレート（A4,A3,B4）です。${formatMeta.description}`
  } else {
    document.title = `${formatMeta.title}   ${to.meta.title}`
    metaDescriptionElement.content = `${formatMeta.title}テンプレート（A4,A3,B4）です。${formatMeta.description}`
  }
  if (to.params.formatId == 'letter') {
    document.title = '履歴書用の' + document.title
  }
  console.log(to)
  if (to.meta.linkformat == 1) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}`
  } else if (to.meta.linkformat == 2) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}`
  } else if (to.meta.linkformat == 3) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit`
  } else if (to.meta.linkformat == 4) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit/${to.params.cardId}`
  } else if (to.meta.linkformat == 5) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit/${to.params.cardId}/preview`
  } else if (to.meta.linkformat == 6) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/${to.path}`
  }
}

const formatExistsOr404 = function (to, from, next) {
  if (!to.params.formatId) {
    next({ name: 'notFound' })
    return
  }
  const id = to.params.formatId
  const formatResult = getFormatById(id)
  if (!formatResult) {
    next({ name: 'notFound' })
    return
  }
  if (!Vue.prototype.$oemContext.isFormatAccessible(id)) {
    next({ name: 'notFound' })
    return
  }
  if (!to.params.cardId) {
    next()
    return
  }
  const cardId = to.params.cardId
  const cardResult = formatResult.cards.find(function (card) { return card.id === cardId })
  if (!cardResult) {
    next({ name: 'notFound' })
    return
  }
  next()
}

// ヤギログが無効の場合、メンテナンスページにリダイレクト
const yagilogGuard = function (to, from, next) {
  if (process.env.VUE_APP_YAGILOG_ENABLED === 'false') {
    next({ path: '/yagilog/maintenance' })
    return
  }
  next()
}

const routes = [
  {
    path: '/',
    component: top,
    name: 'top',
    meta: {
      title: SITE_TITLE,
      linkformat: 1
    }
  },
  {
    path: '/aff/:affId',
    props: true,
    component: top,
    name: 'affi_top',
    meta: {
      title: SITE_TITLE,
      linkformat: 1
    }
  },
  {
    path: '/wordpress',
    props: true,
    component: () => import('@/views/WordPressPage'),
    name: 'portal_page',
    meta: {
      title: SITE_TITLE,
      linkformat: 1
    }
  },
  {
    path: '/oem/:oemId',
    props: true,
    component: top,
    name: 'oem_top',
    meta: {
      title: SITE_TITLE,
      linkformat: 1
    }
  },
  {
    path: '/top',
    component: top_new,
    name: 'top',
    meta: {
      title: SITE_TITLE,
      linkformat: 1
    }
  },
  {
    path: '/keirekisho',
    component: formatKeirekishoList,
    name: 'keirekisho_top',
    meta: {
      title: SITE_TITLE,
      linkformat: 1
    }
  },
  {
    path: '/what',
    component: () => import('@/views/What'),
    name: 'whatPage',
    meta: {
      title: `どれを書く - ${SITE_TITLE}`,
      linkformat: 1
    }
  },
  {
    path: '/format/:formatId',
    component: () => import('@/views/FormatDetail'),
    props: true,
    beforeEnter: formatExistsOr404,
    name: 'formatDetail',
    meta: {
      title: '無料で作成・PDFダウンロード・印刷もできる',
      linkformat: 2
    }
  },
  {
    path: '/format/:formatId/edit',
    component: () => import('@/views/FormatEdit'),
    props: true,
    name: 'formatEdit',
    beforeEnter: formatExistsOr404,
    meta: {
      title: '今すぐ無料で作成・PDFダウンロード・印刷もできる',
      linkformat: 3
    }
  },
  {
    path: '/format/:formatId/edit/:cardId',
    component: () => import('@/views/FormatEdit'),
    props: true,
    name: 'formatEditCard',
    beforeEnter: formatExistsOr404,
    meta: {
      title: '今すぐ無料で作成・PDFダウンロード・印刷もできる',
      linkformat: 4
    }
  },
  {
    path: '/format/:formatId/edit/:cardId/preview',
    component: () => import('@/views/FormatEdit'),
    props: previewProps,
    name: 'formatPreview',
    beforeEnter: formatExistsOr404,
    meta: {
      title: '今すぐ無料で作成・PDFダウンロード・印刷もできる',
      linkformat: 5
    }
  },
  {
    path: '/rtpopup/:uuid',
    component: () => import('@/views/RtPopup'),
    props: true,
    name: 'rtPopup',
    meta: {
      title: `おすすめ情報 - ${SITE_TITLE}`,
      linkformat: 3
    }
  },
  // {
  //   path: '/yagishLightPreview/:uuid',
  //   component: () => import('@/views/YagishLightPreview'),
  //   props: onlyPreviewProps,
  //   name: 'previewOnly',
  //   meta: {
  //     title: `プレビュー - ${SITE_TITLE}`,
  //     linkformat: 6
  //   }
  // },
  {
    path: '/yagioffer/:formatId',
    component: () => import('@/views/YagiofferDetail'),
    props: true,
    beforeEnter: formatExistsOr404,
    name: 'yagiofferDetail',
    meta: {
      title: `テンプレート - ${SITE_TITLE}`,
      linkformat: 2
    }
  },
  {
    path: '/yagioffer/:formatId/edit',
    component: () => import('@/views/YagiofferEdit'),
    props: true,
    name: 'yagiofferEdit',
    beforeEnter: formatExistsOr404,
    meta: {
      title: `編集 - ${SITE_TITLE}`,
      linkformat: 3
    }
  },
  {
    path: '/yagioffer/:formatId/edit/:cardId',
    component: () => import('@/views/YagiofferEdit'),
    props: true,
    name: 'yagiofferEditCard',
    beforeEnter: formatExistsOr404,
    meta: {
      title: `編集 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/recomm/:secureId/:secureKey',
    component: () => import('@/views/pages/Introduction'),
    props: true,
    name: 'IntroductionPage',
    meta: {
      title: `紹介・推薦入力ページ - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の紹介・推薦入力ページです`,
      linkformat: 6
    }
  },
  {
    path: '/recomm/:secureId',
    component: () => import('@/views/pages/Introduction'),
    props: true,
    name: 'IntroductionPage',
    meta: {
      title: `紹介・推薦入力ページ - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の紹介・推薦入力ページです`,
      linkformat: 6
    }
  },
  {
    path: '/recomm_preview/:accessId',
    component: () => import('@/views/IntroductionPreview'),
    props: true,
    name: 'IntroductionPreviewPage',
    meta: {
      title: `紹介・推薦プレビュー - ${SITE_TITLE}`,
      linkformat: 5
    }
  },
  {
    path: '/shogai_recommend/:secureId/:secureKey',
    component: () => import('@/views/pages/ShogaiRecommend'),
    props: true,
    name: 'IntroductionPage',
    meta: {
      title: `紹介・推薦入力ページ - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の紹介・推薦入力ページです`,
      linkformat: 6
    }
  },
  {
    path: '/shogai_recommend/:secureId',
    component: () => import('@/views/pages/ShogaiRecommend'),
    props: true,
    name: 'IntroductionPage',
    meta: {
      title: `紹介・推薦入力ページ - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の紹介・推薦入力ページです`,
      linkformat: 6
    }
  },
  {
    path: '/shogai_recommend_preview/:accessId',
    component: () => import('@/views/ShogaiRecommendPreview'),
    props: true,
    name: 'IntroductionPreviewPage',
    meta: {
      title: `紹介・推薦プレビュー - ${SITE_TITLE}`,
      linkformat: 5
    }
  },
  {
    path: '/shogai_recommend_detail_preview/:accessId/:introDetailId',
    component: () => import('@/views/ShogaiRecommendPreview'),
    props: true,
    name: 'IntroductionShogaiDetailPreviewPage',
    meta: {
      title: `紹介・推薦プレビュー - ${SITE_TITLE}`,
      linkformat: 5
    }
  },
  {
    path: '/athlete/:formatId/:univId',
    component: () => import('@/views/FormatDetail'),
    props: true,
    beforeEnter: formatExistsOr404,
    name: 'formatDetail',
    meta: {
      title: `テンプレート - ${SITE_TITLE}`,
      linkformat: 2
    }
  },
  {
    path: '/help',
    component: () => import('@/views/pages/Help'),
    name: 'helpPage',
    meta: {
      title: `よくある質問 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のよくある質問ページです`,
      linkformat: 6
    }
  },
  {
    path: '/law',
    component: () => import('@/views/pages/Law'),
    name: 'lawPage',
    meta: {
      title: `特定商取引法に基づく表示 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の特定商取引法に基づく表示ページです`,
      linkformat: 6
    }
  },
  {
    path: '/price',
    component: () => import('@/views/pages/Price'),
    name: 'pricePage',
    meta: {
      title: `サービス料金表 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のサービス料金表です`,
      linkformat: 6
    }
  },
  {
    path: '/download',
    component: () => import('@/views/pages/Download'),
    name: 'downloadPage',
    meta: {
      title: `ダウンロード - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のダウンロードページです`,
      linkformat: 6
    }
  },
  {
    path: '/jobdetail_rt',
    component: () => import('@/views/JobdetailRt'),
    name: 'JobdetailRtPage',
    meta: {
      title: `求人詳細リダイレクト - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の求人詳細リダイレクトページです`,
      linkformat: 6
    }
  },
  {
    path: '/request_rt',
    component: () => import('@/views/RequestRT'),
    name: 'RequestRTPage',
    meta: {
      title: `応募リダイレクト - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の応募リダイレクトページです`,
      linkformat: 6
    }
  },
  {
    path: '/request_rt15',
    component: () => import('@/views/RequestRT15'),
    name: 'RequestRT15Page',
    meta: {
      title: `応募リダイレクト - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の応募リダイレクトページです`,
      linkformat: 6
    }
  },
  {
    path: '/click_mailmaga',
    component: () => import('@/views/ClickMailmaga'),
    name: 'ClickMailmagaPage',
    meta: {
      title: `応募完了 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のメルマガ応募完了ページです`,
      linkformat: 6
    }
  },
  {
    path: '/yagiprime_job_application',
    component: () => import('@/views/YagiprimeCaratApplication'),
    name: 'YagiprimeCaratApplicationPage',
    meta: {
      title: `ヤギプライム求人応募 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のヤギプライム求人応募ページです`,
      linkformat: 6
    }
  },
  {
    path: '/job_application',
    component: () => import('@/views/CaratApplication'),
    name: 'caratApplicationPage',
    meta: {
      title: `求人応募 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の求人応募ページです`,
      linkformat: 6
    }
  },
  {
    path: '/toppan_rt',
    component: () => import('@/views/ToppanRt'),
    name: 'ToppanRtPage',
    meta: {
      title: `TOPPAN連携リダイレクト - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のTOPPAN連携のリダイレクトページです`,
      linkformat: 6
    }
  },
  {
    path: '/fontpayment/complete',
    component: () => import('@/views/FontPayPayComplate'),
    name: 'FontPayPayComplatePage',
    meta: {
      title: `フォント購入完了 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の求フォント購入完了ページです`,
      linkformat: 6
    }
  },
  {
    path: '/yagioffer_submit',
    component: () => import('@/views/YagiofferSubmit'),
    name: 'YagiofferSubmitPage',
    meta: {
      title: `オファー承認 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のオファー承認ページです`,
      linkformat: 6
    }
  },
  {
    path: '/yagioffer_favorite',
    component: () => import('@/views/YagiofferFavorite'),
    name: 'YagiofferFavoritePage',
    meta: {
      title: `オファーをキープ - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のオファーキープページです`,
      linkformat: 6
    }
  },
  {
    path: '/bokumetsu',
    component: () => import('@/views/pages/Bokumetsu'),
    name: 'bokumetsuPage',
    meta: {
      title: `手書き履歴書撲滅キャンペーン - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の手書き履歴書撲滅キャンペーンページです`,
      linkformat: 6
    }
  },
  {
    path: '/cvtest',
    component: () => import('@/views/pages/CvTest'),
    name: 'cvtest',
    meta: {
      title: `利用規約 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の利用規約です`,
      linkformat: 6
    }
  },
  {
    path: '/terms',
    component: () => import('@/views/pages/Terms'),
    name: 'termsPage',
    beforeEnter: (to, from, next) => {
      const siteOem = process.env.VUE_APP_SITE_OEM
      const termsRouteName = siteOem && oemConfigs[siteOem]
        ? oemConfigs[siteOem].termsRouteName
        : null
      if (termsRouteName) {
        return next({ name: termsRouteName, replace: true })
      }
      next()
    },
    meta: {
      title: `利用規約 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の利用規約です`,
      linkformat: 6
    }
  },
  {
    path: '/beautyterms',
    component: () => import('@/views/pages/BeautyTerms'),
    name: 'beautytermsPage',
    meta: {
      title: `ヤギッシュDX for Organization 利用規約 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の利用規約です`,
      linkformat: 6
    }
  },
  {
    path: '/terms20231013',
    component: () => import('@/views/pages/Terms20231013'),
    name: 'termsPage',
    meta: {
      title: `利用規約 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の利用規約です`,
      linkformat: 6
    }
  },
  {
    path: '/tempterms',
    component: () => import('@/views/pages/Terms_copy'),
    name: 'termsPage',
    meta: {
      title: `利用規約 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の利用規約です`,
      linkformat: 6
    }
  },
  {
    path: '/quickmailterms',
    component: () => import('@/views/pages/QuickmailTerms'),
    name: 'termsPage',
    meta: {
      title: `ヤギの宅配便の利用規約 - ${SITE_TITLE}`,
      description: 'ヤギの宅配便の利用規約です',
      linkformat: 6
    }
  },
  {
    path: '/quickemailterms',
    component: () => import('@/views/pages/terms/QuickEmailTerms'),
    name: 'termsPage',
    meta: {
      title: `ヤギのメール便の利用規約 - ${SITE_TITLE}`,
      description: 'ヤギのメール便の利用規約です',
      linkformat: 6
    }
  },
  {
    path: '/yagiprimeterms',
    component: () => import('@/views/pages/terms/YagiprimeTerms'),
    name: 'yagiprimetermsPage',
    meta: {
      title: `ヤギプライムの利用規約 - ${SITE_TITLE}`,
      description: 'ヤギプライムの利用規約です',
      linkformat: 6
    }
  },
  {
    path: '/yagiworksterms',
    component: () => import('@/views/pages/terms/YagiworksTerms'),
    name: 'yagiworkstermsPage',
    meta: {
      title: `ヤギワークスの利用規約 - ${SITE_TITLE}`,
      description: 'ヤギワークスの利用規約です',
      linkformat: 6
    }
  },
  {
    path: '/qmail_preview/:confirmCode',
    component: () => import('@/views/QuickEmailPreview'),
    props: true,
    name: 'QuickEmailPreview',
    meta: {
      title: `プレビュー - ${SITE_TITLE}`,
      linkformat: 5
    }
  },
  {
    path: '/yagiofferterms',
    component: () => import('@/views/pages/YagiofferTerms'),
    name: 'termsPage',
    meta: {
      title: `ヤギオファーの利用規約 - ${SITE_TITLE}`,
      description: 'ヤギオファーの利用規約です',
      linkformat: 6
    }
  },
  {
    path: '/fontservicehelp',
    component: () => import('@/views/pages/FontHelp'),
    name: 'fontServiceHelpPage',
    meta: {
      title: `有料フォントの利用方法 - ${SITE_TITLE}`,
      description: '有料フォントの利用方法説明ページです',
      linkformat: 6
    }
  },
  {
    path: '/quickmailhelp',
    component: () => import('@/views/pages/QuickmailHelp'),
    name: 'termsPage',
    meta: {
      title: `ヤギの宅配便の利用方法 - ${SITE_TITLE}`,
      description: 'ヤギの宅配便の利用方法説明ページです。',
      linkformat: 6
    }
  },
  {
    path: '/yagiprimeinfo',
    component: () => import('@/views/pages/YagiprimeInfo'),
    name: 'yagiprimeinfoPage',
    meta: {
      title: `ヤギプライムの利用方法 - ${SITE_TITLE}`,
      description: 'ヤギプライムの利用方法説明ページです。',
      linkformat: 6
    }
  },
  {
    path: '/_tempyagioffer-esf',
    component: () => import('@/views/pages/ShogaisyaLP'),
    props: true,
    name: 'shogaiPage',
    meta: {
      title: '就労支援施設の方へ｜ヤギオファー',
      description: '就労支援施設の方へ',
      linkformat: 6
    }
  },
  {
    path: '/okinavi',
    component: () => import('@/views/pages/Okinavi'),
    props: true,
    name: 'okinaviPage',
    meta: {
      title: `沖縄ナビ - ${SITE_TITLE}`,
      description: '沖縄ナビページです。',
      linkformat: 6
    }
  },
  {
    path: '/quickemailhelp',
    component: () => import('@/views/pages/QuickEmailHelp'),
    name: 'termsPage',
    meta: {
      title: `ヤギのメール便の利用方法 - ${SITE_TITLE}`,
      description: 'ヤギのメール便の利用方法説明ページです',
      linkformat: 6
    }
  },
  {
    path: '/yagifriendshelp',
    component: () => import('@/views/pages/YagiFriendsHelp'),
    name: 'yagiFriendsHelpPage',
    meta: {
      title: `ヤギフレンズの使い方 - ${SITE_TITLE}`,
      description: 'ヤギフレンズの使い方説明ページです',
      requiresAuth: true,
      linkformat: 6
    }
  },
  {
    path: '/quickemailforcompany',
    component: () => import('@/views/pages/QuickEmailforCompany'),
    name: 'termsPage',
    meta: {
      title: `企業向け紹介ヤギのメール便 - ${SITE_TITLE}`,
      description: 'ヤギのメール便の企業向け紹介ページです',
      linkformat: 6
    }
  },
  {
    path: '/yagiofferhelp',
    component: () => import('@/views/pages/YagiofferHelp'),
    name: 'yagiofferHelpPage',
    meta: {
      title: `ヤギオファーの利用方法 - ${SITE_TITLE}`,
      description: 'ヤギオファーの利用方法説明ページです',
      linkformat: 6
    }
  },
  {
    path: '/privacy',
    name: 'policyPage',
    beforeEnter() {
      // 外部サイトにリダイレクト
      window.location.href = 'https://www.yagish.jp/privacy/'
    }
    // component: () => import('@/views/pages/Privacy'),
    // name: 'policyPage',
    // meta: {
    //   title: `個人情報保護方針 - ${SITE_TITLE}`,
    //   description: `${SITE_TITLE}の個人情報保護方針です`,
    //   linkformat: 6
    // }
  },
  {
    path: '/company',
    name: 'companyPage',
    beforeEnter() {
      window.location = 'https://www.yagish.jp'
    }
    // component: () => import('@/views/pages/Company'),
    // name: 'companyPage',
    // meta: {
    //   title: `会社紹介 - ${SITE_TITLE}`,
    //   description: `${SITE_TITLE}の会社紹介です`,
    //   linkformat: 6
    // }
  },
  {
    path: '/checklist_jobchange/:formatId/:cardId',
    component: () => import('@/views/pages/Jobagree'),
    name: 'JobagreePage',
    meta: {
      title: `「転職活動チェックリスト」で準備、対策、進め方を把握しよう！ - ${SITE_TITLE}`,
      description: `転職活動はいざ始まると忙しくなるので、予めやることをチェックリストで把握しておくことが大切です。
      Yagish(ヤギッシュ)は「自己分析」「履歴書・職歴書の添削」「退職手続き」「自分に合った会社の選定」など効率の良い転職活動をサポートします。`,
      linkformat: 6
    }
  },
  // {
  //   path: '/quickmail/:cardId',
  //   component: () => import('@/views/YagiPrimeQuickMailService'),
  //   props: true,
  //   name: 'quickmailCard',
  //   meta: {
  //     title: `ヤギの宅配便 - ${SITE_TITLE}`,
  //     linkformat: 4
  //   }
  // },
  {
    path: '/yagiprimequickmail/:cardId',
    component: () => import('@/views/YagiPrimeQuickMailService'),
    props: true,
    name: 'yagiprimequickmailCard',
    meta: {
      title: `ヤギの宅配便 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/yagiprimequickemail/:cardId',
    component: () => import('@/views/YagiPrimeQuickEMailService'),
    props: true,
    name: 'yagiprimeQuickemailCard',
    meta: {
      title: `ヤギのメール便 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/newquickemail/:cardId',
    component: () => import('@/views/NewQuickEMailService'),
    props: true,
    name: 'newQuickemailCard',
    meta: {
      title: `ヤギのメール便 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/quickemail/:cardId',
    component: () => import('@/views/YagiPrimeQuickEMailService'),
    props: true,
    name: 'quickemailCard',
    meta: {
      title: `ヤギのメール便 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/info',
    component: () => import('@/views/pages/ServiceInfo'),
    name: 'serviceInfoPage',
    meta: {
      title: `このサービスについて - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のサービスについて説明です`,
      linkformat: 6
    }
  },
  {
    path: '/mailmaga/:clientId',
    component: () => import('@/views/pages/Mailmaga'),
    name: 'mailMagaPage',
    props: true,
    meta: {
      title: `おすすめ情報 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}からあなたにおすすめ情報を紹介するページです`,
      linkformat: 6
    }
  },
  {
    path: '/yagioffer_company/:offerUid/:uid',
    component: () => import('@/views/pages/YagiofferCompany'),
    name: 'yagiofferCampanyPage',
    props: true,
    meta: {
      title: `オファー企業情報 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}からオファー企業を紹介するページです`,
      linkformat: 6
    }
  },
  {
    path: '/yagiworklogin',
    component: () => import('@/views/pages/Yagiworklogin'),
    name: 'YagiworkloginPage',
    meta: {
      title: `ヤギワークスログイン - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のヤギワークスログインページです`,
      linkformat: 6
    }
  },
  {
    path: '/oldlogin',
    component: () => import('@/views/pages/Login'),
    name: 'loginPageOld',
    meta: {
      title: `ログイン - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のログインページです`,
      linkformat: 6
    }
  },
  {
    path: '/idpwlogin',
    component: () => import('@/views/pages/IdPwLogin'),
    name: 'loginPageIdpw',
    meta: {
      title: `ログイン - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のログインページです`,
      linkformat: 6
    }
  },
  {
    path: '/login',
    component: () => import('@/views/pages/NewLogin'),
    name: 'loginPage',
    meta: {
      title: `ログイン - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のログインページです`,
      linkformat: 6
    }
  },
  {
    path: '/mregister',
    component: () => import('@/views/pages/Register'),
    name: 'registerPage',
    meta: {
      title: `会員登録 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の会員登録ページです`,
      linkformat: 6
    }
  },
  {
    path: '/oldmypage',
    component: () => import('@/views/pages/OldMyPage'),
    name: 'oldmyPage',
    meta: {
      title: `マイページ - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の旧マイページです`,
      linkformat: 6
    }
  },
  {
    path: '/repasswd',
    component: () => import('@/views/pages/RePasswd'),
    name: 'rePasswdPage',
    meta: {
      title: `パスワード再発行 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のパスワード再発行ページです`,
      linkformat: 6
    }
  },
  {
    path: '/mypage/basicinfo',
    component: () => import('@/views/pages/mypage/BasicinfoMyPage'),
    name: 'basicinfoMyPage',
    meta: {
      title: `マイページ:メールアドレスの変更 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイページ:メールアドレスの変更ページです`,
      linkformat: 6
    }
  },
  // {
  //   path: '/mypage/basicinfo',
  //   component: () => import('@/views/pages/oldmypage/BasicinfoMyPage'),
  //   name: 'basicinfoMyPage',
  //   meta: {
  //     title: `マイページ:メールアドレスの変更 - ${SITE_TITLE}`,
  //     description: `${SITE_TITLE}のマイページ:メールアドレスの変更ページです`,
  //     linkformat: 6
  //   }
  // },
  {
    path: '/infosave',
    component: () => import('@/views/pages/ServiceInfoSave'),
    name: 'serviceInfoSavePage',
    meta: {
      title: `入力した情報の保存ついて - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の入力した情報の保存について説明です`,
      linkformat: 6
    }
  },
  {
    path: '/postcard',
    component: () => import('@/views/YagiPostCard'),
    name: 'postCard',
    meta: {
      title: `ヤギにハガキを渡す - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の運営元宛てのハガキをヤギに頼めます`,
      linkformat: 6
    }
  },
  {
    path: '/gacha',
    component: () => import('@/views/YagiGacha'),
    name: 'gacha',
    meta: {
      title: `ガチャ - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - ガチャ`,
      linkformat: 6
    }
  },
  {
    path: '/hiroba',
    component: () => import('@/views/YagiHiroba'),
    name: 'hiroba',
    meta: {
      title: `広場 - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - 広場`,
      linkformat: 6
    }
  },
  // YagiFriends関連
  {
    path: '/yagifriends',
    component: () => import('@/views/pages/yagifriends/YagiFriendsTop'),
    name: 'yagiFriendsTop',
    meta: {
      title: `yagifriends - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - yagifriends`,
      linkformat: 6
    }
  },
  {
    path: '/yagifriends/myprofile',
    component: () => import('@/views/pages/yagifriends/YagiFriendsMyProfile'),
    name: 'yagiFriendsMyProfile',
    meta: {
      title: `プロフィール - yagifriends - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - yagifriends プロフィール`,
      linkformat: 6
    }
  },
  {
    path: '/yagifriends/chat',
    component: () => import('@/views/pages/yagifriends/YagiFriendsChat'),
    name: 'yagiFriendsChat',
    meta: {
      title: `チャット - yagifriends - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - yagifriends チャット`,
      linkformat: 6
    }
  },
  {
    path: '/yagifriends/groups',
    component: () => import('@/views/pages/yagifriends/YagiFriendsGoEN'),
    name: 'yagiFriendsGoEN',
    meta: {
      title: `グループ一覧【Go縁】 - yagifriends - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - yagifriends Go縁`,
      linkformat: 6
    }
  },
  {
    path: '/yagifriends/groups/create',
    component: () => import('@/views/pages/yagifriends/YagiFriendsCreateGroup'),
    name: 'yagiFriendsCreateGroup',
    meta: {
      title: `グループ作成 - yagifriends - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - yagifriends グループ作成`,
      linkformat: 6
    }
  },
  {
    path: '/yagifriends/groups/:id/edit',
    component: () => import('@/views/pages/yagifriends/YagiFriendsGroupEdit'),
    name: 'yagiFriendsGroupEdit',
    meta: {
      title: `グループ編集 - yagifriends - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - yagifriends グループ編集`,
      linkformat: 6
    }
  },
  {
    path: '/yagifriends/groups/:id/invite',
    component: () => import('@/views/pages/yagifriends/YagiFriendsInvite'),
    name: 'yagiFriendsInvite',
    meta: {
      title: `グループ招待 - yagifriends - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - yagifriends グループ招待`,
      linkformat: 6
    }
  },
  {
    path: '/yagifriends/invitation/:code',
    component: () => import('@/views/pages/yagifriends/YagiFriendsInvitationLanding'),
    name: 'yagiFriendsInvitationLanding',
    meta: {
      title: `招待 - yagifriends - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - yagifriends 招待`,
      linkformat: 6
    }
  },
  {
    path: '/yagifriends/terms',
    component: () => import('@/views/pages/yagifriends/Terms'),
    name: 'yagiFriendsTerms',
    meta: {
      title: `利用規約 - yagifriends - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - yagifriends 利用規約`,
      linkformat: 6
    }
  },
  {
    path: '/yagifriends/rules',
    component: () => import('@/views/pages/yagifriends/YagiFriendsProhibited'),
    name: 'yagiFriendsRules',
    meta: {
      title: `禁止事項 - yagifriends - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - yagifriends 禁止事項`,
      linkformat: 6
    }
  },
  {
    path: '/yagifriends/guide',
    component: () => import('@/views/pages/yagifriends/YagiFriendsGuide'),
    name: 'yagiFriendsGuide',
    meta: {
      title: `使い方ガイド - yagifriends - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - yagifriends 使い方ガイド`,
      linkformat: 6
    }
  },

  // ヤギプライム関連
  {
    path: '/yagiprime_register',
    component: () => import('@/views/pages/yagiprime/YagiprimeRegister'),
    name: 'yagiprimeRegisterPage',
    meta: {
      title: `ヤギプライム登録 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のヤギプライム登録ページです`,
      linkformat: 6
    }
  },
  {
    path: '/tempyagiprime_register',
    component: () => import('@/views/pages/yagiprime/YagiprimeRegisterTemp'),
    name: 'tempyagiprimeRegisterPage',
    meta: {
      title: `tempヤギプライム登録 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のtempヤギプライム登録ページです`,
      linkformat: 6
    }
  },
  {
    path: '/yagiprimecancel',
    component: () => import('@/views/pages/yagiprime/YagiprimeCancel'),
    name: 'yagiprimeCancelPage',
    meta: {
      title: `ヤギプライム解除 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のヤギプライム解除ページです`,
      linkformat: 6
    }
  },
  {
    path: '/mypage',
    component: () => import('@/views/pages/mypage/MyPage'),
    name: 'myPage',
    meta: {
      title: `マイページ - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイページです`,
      linkformat: 6,
      requiresAuth: true
    }
  },
  // {
  //   path: '/mypage',
  //   component: () => import('@/views/pages/oldmypage/MyPage'),
  //   name: 'myPage',
  //   meta: {
  //     title: `マイページ - ${SITE_TITLE}`,
  //     description: `${SITE_TITLE}のマイページです`,
  //     linkformat: 6,
  //     requiresAuth: true
  //   }
  // },
  {
    path: '/mypage/rirekishoedit',
    component: () => import('@/views/pages/mypage/MyPageRirekishoEdit'),
    name: 'rirekishoedit',
    meta: {
      title: `マイページ上で履歴書編集 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイ履歴書編集ページです`,
      linkformat: 6,
      requiresAuth: true
    }
  },
  // {
  //   path: '/rirekisholist',
  //   component: () => import('@/views/pages/mypage/MyPageRirekisyoList'),
  //   name: 'rirekisholist',
  //   meta: {
  //     title: `テンプレート一覧 - ${SITE_TITLE}`,
  //     description: `${SITE_TITLE}のマイテンプレート一覧です`,
  //     linkformat: 6
  //   }
  // },
  {
    path: '/servicelist',
    component: () => import('@/views/pages/mypage/MyPageServicelist'),
    name: 'myServicelist',
    meta: {
      title: `サービス一覧 - ${SITE_TITLE}`,
      description: 'ヤギッシュのサービス一覧です',
      linkformat: 6
    }
  },
  // {
  //   path: '/servicelist',
  //   component: () => import('@/views/pages/oldmypage/MyPageServicelist'),
  //   name: 'myServicelist',
  //   meta: {
  //     title: `サービス一覧 - ${SITE_TITLE}`,
  //     description: `ヤギッシュのサービス一覧です`,
  //     linkformat: 6
  //   }
  // },
  {
    path: '/mypage/account',
    component: () => import('@/views/pages/mypage/MyPageAccount'),
    name: 'myAccountPage',
    meta: {
      title: `マイページ:アカウント情報 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイページ:アカウント情報です`,
      linkformat: 6,
      requiresAuth: true
    }
  },
  {
    path: '/template-app',
    component: () => import('@/views/pages/TemplateAppRedirect'),
    name: 'templateAppRedirect',
    meta: {
      title: `書類テンプレートアプリ - ${SITE_TITLE}`,
      description: `書類テンプレートアプリ`,
      requiresAuth: true
    }
  },
  // {
  //   path: '/mypage/account',
  //   component: () => import('@/views/pages/oldmypage/MyPageAccount'),
  //   name: 'myAccountPage',
  //   meta: {
  //     title: `マイページ:アカウント情報 - ${SITE_TITLE}`,
  //     description: `${SITE_TITLE}のマイページ:アカウント情報です`,
  //     linkformat: 6,
  //     requiresAuth: true
  //   }
  // },
  {
    path: '/mypage/yagioffer',
    component: () => import('@/views/pages/mypage/MyPageYagioffer'),
    name: 'myYagiofferPage',
    meta: {
      title: `マイページ:ヤギオファー - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイページ:ヤギオファーです`,
      linkformat: 6,
      requiresAuth: true
    }
  },
  // {
  //   path: '/mypage/yagioffer',
  //   component: () => import('@/views/pages/oldmypage/MyPageYagioffer'),
  //   name: 'myYagiofferPage',
  //   meta: {
  //     title: `マイページ:ヤギオファー - ${SITE_TITLE}`,
  //     description: `${SITE_TITLE}のマイページ:ヤギオファーです`,
  //     linkformat: 6,
  //     requiresAuth: true
  //   }
  // },
  {
    path: '/mypage/yagioffer/ngcompany',
    component: () => import('@/views/pages/mypage/MyPageYagiofferNgcompany'),
    name: 'myNgcompanyPage',
    meta: {
      title: `マイページ:ヤギオファー - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイページ:ヤギオファーです`,
      linkformat: 6,
      requiresAuth: true
    }
  },
  // {
  //   path: '/mypage/yagioffer/ngcompany',
  //   component: () => import('@/views/pages/oldmypage/MyPageYagiofferNgcompany'),
  //   name: 'myNgcompanyPage',
  //   meta: {
  //     title: `マイページ:ヤギオファー - ${SITE_TITLE}`,
  //     description: `${SITE_TITLE}のマイページ:ヤギオファーです`,
  //     linkformat: 6,
  //     requiresAuth: true
  //   }
  // },
  {
    path: '/mypage/quickemaillist',
    component: () => import('@/views/pages/mypage/MyPageQuickemail'),
    name: 'myQuickemaillistPage',
    meta: {
      title: `マイページ:ヤギのメール便 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイページ:ヤギのメール便です`,
      linkformat: 6,
      requiresAuth: true
    }
  },
  // {
  //   path: '/mypage/quickemaillist',
  //   component: () => import('@/views/pages/oldmypage/MyPageQuickemail'),
  //   name: 'myQuickemaillistPage',
  //   meta: {
  //     title: `マイページ:ヤギのメール便 - ${SITE_TITLE}`,
  //     description: `${SITE_TITLE}のマイページ:ヤギのメール便です`,
  //     linkformat: 6,
  //     requiresAuth: true
  //   }
  // },
  {
    path: '/mypage/yagiorder',
    component: () => import('@/views/pages/mypage/MyPageYagiorder'),
    name: 'myYagiorderPage',
    meta: {
      title: `マイページ:購入済み - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイページ:購入済みです`,
      linkformat: 6,
      requiresAuth: true
    }
  },
  // {
  //   path: '/mypage/yagiorder',
  //   component: () => import('@/views/pages/oldmypage/MyPageYagiorder'),
  //   name: 'myYagiorderPage',
  //   meta: {
  //     title: `マイページ:購入済み - ${SITE_TITLE}`,
  //     description: `${SITE_TITLE}のマイページ:購入済みです`,
  //     linkformat: 6,
  //     requiresAuth: true
  //   }
  // },
  {
    path: '/mypage/yagiprime',
    component: () => import('@/views/pages/mypage/MyPageYagiprime'),
    name: 'myYagiprime',
    meta: {
      title: `マイページ:ヤギプライム - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイページ:ヤギプライムです`,
      linkformat: 6,
      requiresAuth: true
    }
  },
  // {
  //   path: '/mypage/yagiprime',
  //   component: () => import('@/views/pages/oldmypage/MyPageYagiprime'),
  //   name: 'myYagiprime',
  //   meta: {
  //     title: `マイページ:ヤギプライム - ${SITE_TITLE}`,
  //     linkformat: 6,
  //     requiresAuth: true
  //   }
  // },
  {
    path: '/yagiprime/:cardId',
    component: () => import('@/views/pages/yagiprime/YagiPrimeSettingService'),
    props: true,
    name: 'yagiPrimeCard',
    meta: {
      title: `ヤギプライム希望職種設定 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/yagilog/maintenance',
    component: () => import('@/views/pages/yagiprime/YagiLogMaintenance'),
    name: 'yagiLogMaintenance',
    meta: {
      title: `ヤギログ - メンテナンス中 - ${SITE_TITLE}`,
      linkformat: 6
    }
  },
  {
    path: '/yagilog/list',
    component: () => import('@/views/pages/yagiprime/YagiPrimeYagiLogSetting'),
    props: { step: 'list' },
    name: 'yagiLogList',
    beforeEnter: yagilogGuard,
    meta: {
      title: `ヤギログ - キャリアアドバイザー一覧 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/yagilog/confirm',
    component: () => import('@/views/pages/yagiprime/YagiPrimeYagiLogSetting'),
    props: { step: 'confirm' },
    name: 'yagiLogConfirm',
    beforeEnter: yagilogGuard,
    meta: {
      title: `ヤギログ - 確認 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/yagilog/complete',
    component: () => import('@/views/pages/yagiprime/YagiPrimeYagiLogSetting'),
    props: { step: 'complete' },
    name: 'yagiLogComplete',
    beforeEnter: yagilogGuard,
    meta: {
      title: `ヤギログ - 完了 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/ai/interview_start',
    component: () => import('@/views/pages/ai/InterviewStart'),
    props: true,
    name: 'interviewStart',
    meta: {
      title: `AI面接練習(β版)のリスト - ${SITE_TITLE}`,
      linkformat: 6
    }
  },
  {
    path: '/ai/interview_practice',
    component: () => import('@/views/pages/ai/InterviewChat'),
    props: true,
    name: 'interviewChat',
    meta: {
      title: `AI面接練習(β版) - ${SITE_TITLE}`,
      linkformat: 6
    }
  },
  {
    path: '/ai/voice_interview_practice',
    component: () => import('@/views/pages/ai/VoiceInterviewChat'),
    props: true,
    name: 'voiceInterviewChat',
    meta: {
      title: `音声でAI面接練習(β版) - ${SITE_TITLE}`,
      linkformat: 6
    }
  },

  {
    path: '/ai/aptitude_practice',
    component: () => import('@/views/pages/ai/AptitudeChat'),
    props: true,
    name: 'aptitudeChat',
    meta: {
      title: `適性検査練習(β版) - ${SITE_TITLE}`,
      linkformat: 6
    }
  },
  {
    path: '/ai/self_analysis',
    component: () => import('@/views/pages/ai/SelfAnalysisChat'),
    props: true,
    name: 'selfAnalysisChat',
    meta: {
      title: `自己分析(β版) - ${SITE_TITLE}`,
      linkformat: 6
    }
  },

  {
    path: '/yagiprime_adlp_interview',
    component: () => import('@/views/pages/YagiprimeAdlpInterview'),
    props: true,
    name: 'yagiprimeAdlpInterview',
    meta: {
      title: `AI面接練習 - ${SITE_TITLE}`,
      linkformat: 6
    }
  },

  {
    path: '/recognition',
    component: () => import('@/views/pages/Recognition'),
    props: true,
    name: 'Recognition',
    meta: {
      title: `書類をアップロードする - ${SITE_TITLE}`,
      linkformat: 6
    }
  },

  {
    path: '/idphotoprint',
    component: () => import('@/views/pages/Idphotoprint'),
    props: true,
    name: 'Idphotoprint',
    meta: {
      title: `証明写真を印刷する - ${SITE_TITLE}`,
      linkformat: 6
    }
  },

  {
    path: '/contact',
    component: () => import('@/views/ContactView.vue'),
    props: true,
    name: 'Contact',
    meta: {
      title: `お問い合わせ - ${SITE_TITLE}`
    }
  },
  {
    path: '/yagiprime_adlp_rirekisho',
    component: () => import('@/views/pages/YagiprimeSAdlpRirekisho'),
    props: true,
    name: 'yagiprimeSAdlpRirekisho',
    meta: {
      title: `AI履歴書 - ${SITE_TITLE}`,
      linkformat: 6
    }
  },
  {
    path: '/yagiprime_superagent',
    component: () => import('@/views/pages/YagiprimeAgentLp'),
    props: true,
    name: 'YagiprimeAgentLp',
    meta: {
      title: `エージェントサービス - ${SITE_TITLE}`,
      linkformat: 6
    }
  },
  {
    path: '/yagiprime_superagent_new',
    component: () => import('@/views/pages/YagiprimeNewAgentLp'),
    props: true,
    name: 'YagiprimeNewAgentLp',
    meta: {
      title: `新卒エージェントサービス - ${SITE_TITLE}`,
      linkformat: 6
    }
  },
  {
    path: '/regist_agent',
    component: () => import('@/views/RTRegister'),
    props: true,
    name: 'RTRegister',
    meta: {
      title: `無料相談応募 - ${SITE_TITLE}`,
      linkformat: 6
    }
  },
  {
    path: '/yagidigram',
    component: () => import('@/views/pages/yagidigram/YagiDigramHelp'),
    props: true,
    name: 'yagidigram',
    meta: {
      title: `ヤギッシュでディグラム診断 - ${SITE_TITLE}`,
      linkformat: 6
    }
  },
  {
    path: '/yagidigram/yagidigramexam',
    component: () => import('@/views/pages/yagidigram/YagiDigramExam'),
    props: true,
    name: 'yagidigramexam',
    meta: {
      title: `診断中｜ヤギッシュでディグラム診断 - ${SITE_TITLE}`,
      linkformat: 6
    }
  },
  {
    path: '/yagidigram/yagidigramresult',
    component: () => import('@/views/pages/yagidigram/YagiDigramResult'),
    props: true,
    name: 'yagidigramresult',
    meta: {
      title: `結果発表｜ヤギッシュでディグラム診断 - ${SITE_TITLE}`,
      linkformat: 6
    }
  },
  // {
  //   path: '/eprinthelp',
  //   component: () => import('@/views/pages/EprintHelp'),
  //   props: true,
  //   name: 'eprinthelp',
  //   meta: {
  //     title: `ヤギッシュのコンビニ印刷 - ${SITE_TITLE}`,
  //     linkformat: 6
  //   }
  // },
  {
    path: '/yagidia/:jobId',
    component: () => import('@/views/pages/yagidia/Yagidia'),
    props: true,
    name: 'yagidia',
    meta: {
      title: `ヤギディア詳細画面 - ${SITE_TITLE}`,
      linkformat: 6
    }
  },

  // Aptitude Tekisei Routes
  {
    path: '/aptitude/tekisei/login',
    component: () => import('@/views/aptitude/tekisei/TekiseiLogin'),
    name: 'aptitude-tekisei-login',
    meta: {
      title: '受験者ログイン - 適性検査',
      linkformat: 6
    }
  },
  {
    path: '/aptitude/tekisei/home',
    component: () => import('@/views/aptitude/tekisei/TekiseiHome'),
    name: 'aptitude-tekisei-home',
    meta: {
      title: 'ホーム - 適性検査',
      linkformat: 6
    }
  },
  {
    path: '/aptitude/tekisei/main/ds',
    component: () => import('@/views/aptitude/tekisei/TekiseiMainDs'),
    name: 'aptitude-tekisei-main-ds',
    meta: {
      title: '適性検査 - 適性検査',
      linkformat: 6
    }
  },
  {
    path: '/aptitude/tekisei/main/iqs',
    component: () => import('@/views/aptitude/tekisei/TekiseiMainIqs'),
    name: 'aptitude-tekisei-main-iqs',
    meta: {
      title: 'IQSテスト - 適性検査',
      linkformat: 6
    }
  },
  {
    path: '/aptitude/tekisei/main/iqp',
    component: () => import('@/views/aptitude/tekisei/TekiseiMainIqp'),
    name: 'aptitude-tekisei-main-iqp',
    meta: {
      title: 'IQPテスト - 適性検査',
      linkformat: 6
    }
  },
  {
    path: '/aptitude/tekisei/main/ps',
    component: () => import('@/views/aptitude/tekisei/TekiseiMainPs'),
    name: 'aptitude-tekisei-main-ps',
    meta: {
      title: '記述式質問 - 適性検査',
      linkformat: 6
    }
  },
  {
    path: '/aptitude/tekisei/survey/ds',
    component: () => import('@/views/aptitude/tekisei/TekiseiSurveyDs'),
    name: 'aptitude-tekisei-survey-ds',
    meta: {
      title: '適性検査実施 - 適性検査',
      linkformat: 6
    }
  },
  {
    path: '/aptitude/tekisei/survey/iqs',
    component: () => import('@/views/aptitude/tekisei/TekiseiSurveyIqs'),
    name: 'aptitude-tekisei-survey-iqs',
    meta: {
      title: 'IQSテスト実施 - 適性検査',
      linkformat: 6
    }
  },
  {
    path: '/aptitude/tekisei/survey/iqp',
    component: () => import('@/views/aptitude/tekisei/TekiseiSurveyIqp'),
    name: 'aptitude-tekisei-survey-iqp',
    meta: {
      title: 'IQPテスト実施 - 適性検査',
      linkformat: 6
    }
  },
  {
    path: '/aptitude/tekisei/survey/ps',
    component: () => import('@/views/aptitude/tekisei/TekiseiSurveyPs'),
    name: 'aptitude-tekisei-survey-ps',
    meta: {
      title: '記述式質問実施 - 適性検査',
      linkformat: 6
    }
  },

  {
    path: '/maintenance',
    component: () => import('@/views/pages/Maintenance'),
    name: 'maintenancePage',
    meta: {
      title: `システムメンテナンス中 - ${SITE_TITLE}`,
      linkformat: 1
    }
  },
  {
    path: NOT_FOUND_PATH,
    component: () => import('@/views/NotFound'),
    alias: ['/404.html'],
    name: 'notFound',
    meta: {
      title: `ページが見つかりません - ${SITE_TITLE}`,
      linkformat: 1
    }
  },
  {
    path: '/:oemUniqueId?',
    component: top,
    props: true,
    beforeEnter: (to, from, next) => {
      const parent = process.env.VUE_APP_SITE_OEM
      const { oemUniqueId } = to.params
      if (!parent) {
        return next({ name: 'notFound' })
      }
      if (!oemUniqueId) {
        return next()
      }
      if (!Vue.prototype.$oemContext.isValidChild(parent, oemUniqueId)) {
        return next({ name: 'notFound' })
      }
      next()
    }
  },
  {
    path: '*',
    redirect: { name: 'notFound' }
  }
]
if (process.env.VUE_APP_MODE === 'development') {
  routes.push({
    path: '/admin',
    component: () => import('@/views/AdminIndex'),
    name: 'adminIndex',
    meta: {
      title: `管理用 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}で入力したデータのバックアップ作成やプレビュー、復元をすることができます。`
    }
  })
}
const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior: function (to, from, savedPosition) {
    if (savedPosition) return savedPosition
    // カード間の移動時は
    // 最上部へのスクロールを無視する
    if (to.name === 'formatEditCard' && from.name === 'formatEditCard') {
      return
    }
    return { x: 0, y: 0 }
  }
})
const flag_temp = '12312312312'

router.beforeEach(async (to, from, next) => {
  // メンテナンスモード: 全ルートをメンテナンスページへリダイレクト
  if (process.env.VUE_APP_MAINTENANCE === 'true' && to.name !== 'maintenancePage') {
    return next({ name: 'maintenancePage' })
  }

  // 過去バージョンの不具合で basicData に混入した巨大データを除去する。
  // 初回のみ走り、想定外キーが無ければ書き込みもスキップする。
  await autoHealStoredBasicData()

  if (Vue.prototype.$firebase && Vue.prototype.$firebase.authReady) {
    await Vue.prototype.$firebase.authReady
  }

  let isLoggedIn = Vue.prototype.$firebase.isAuthenticated

  // LINE ログイン等、未ログインで custom_token 付きで /mypage に戻るケースで
  // 認証ガードより先にカスタムトークンでサインインさせる
  // （ref: yagish_light/line-login/main.py → `{base_url}/mypage?custom_token=...`）
  if (!isLoggedIn && to.path === '/mypage' && to.query.custom_token) {
    try {
      const credential = await firebase.auth().signInWithCustomToken(to.query.custom_token)
      isLoggedIn = !!(credential && credential.user)
    } catch (err) {
      console.error('signInWithCustomToken failed in router guard:', err)
    }
  }

  // メールリンクログイン (Firebase Email Link Sign-In) も同型の受領処理。
  // 認証ガードより先に signInWithEmailLink でサインインしておかないと、
  // requiresAuth で /login にリダイレクトされて oobCode が消失する。
  if (!isLoggedIn && firebase.auth().isSignInWithEmailLink(window.location.href)) {
    try {
      let email = await Vue.prototype.$firebase.$getItem('emailForSignIn')
      if (!email) {
        email = window.prompt(
          '別の端末でログインする場合、安全のため再度メールアドレスを入力してください。\n※一度使用したメールリンクは無効となります'
        )
      }
      if (email) {
        const credential = await firebase.auth().signInWithEmailLink(email, window.location.href)
        isLoggedIn = !!(credential && credential.user)
        await Vue.prototype.$firebase.$removeItem('emailForSignIn')
      }
    } catch (err) {
      console.error('signInWithEmailLink failed in router guard:', err)
    }
  }

  // ログイン後マイページの施策は一旦取りやめ
  // if (to.path === '/') {
  //   if (isLoggedIn) {
  //     if (to.query.to_top === 'true') {
  //       return next()
  //     }
  //     return next({ name: 'myPage' })
  //   }
  // }

  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    return next({ name: 'loginPage' })
  }
  next()
})

const metaDescriptionElement = document.getElementById('head-meta-description')
const headLinkCanonical = document.getElementById('head-link-canonical')
const defaultDescription = metaDescriptionElement.content
router.afterEach((to, from) => {
  if (to.params.formatId) {
    setFormatMeta(to)
  } else if (to.meta && to.meta.title) {
    document.title = to.meta.title
    if (to.meta.description) {
      metaDescriptionElement.content = to.meta.description
    } else {
      metaDescriptionElement.content = defaultDescription
    }
    if (to.meta.linkformat == 1) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}`
    } else if (to.meta.linkformat == 2) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}`
    } else if (to.meta.linkformat == 3) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit`
    } else if (to.meta.linkformat == 4) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit/${to.params.cardId}`
    } else if (to.meta.linkformat == 5) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit/${to.params.cardId}/preview`
    } else if (to.meta.linkformat == 6) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}${to.path}`
    }
  }
  /**
   * =========================
   * OEM Context 同期
   * =========================
   */
  if (Vue.prototype.$oemContext) {
    Vue.prototype.$oemContext.syncFromRoute(to)
  }
})
export default router

